import { differenceInDays } from 'date-fns';

export const formatDate = (value?: string) => {
    if (!value) return '';
    
    const [year, month, day] = value.split('-');
    return `${day}/${month}/${year}`;
};

export const formatTerm = (value?: string | number | null) => {
    const num = Number(value);
    if (!value || isNaN(num)) return '';

    const years = Math.floor(num / 12);
    const months = num % 12;

    if (years && months) return `${years}y ${months}m`;
    if (years) return `${years}y`;
    return `${months}m`;
};

export const getMaturityColor = (maturityDate?: string) => {
    if (!maturityDate) return { backgroundColor: 'inherit', color: 'inherit' };

    const today = new Date();
    const diffDays = differenceInDays(new Date(maturityDate), today);

    if (diffDays < 0) return { backgroundColor: 'red', color: 'white' };
    if (diffDays <= 7) return { backgroundColor: 'orange', color: 'white' };
    if (diffDays <= 14) return { backgroundColor: '#FAF9F6', color: 'black' };

    return { backgroundColor: 'inherit', color: 'inherit' };
};

export const sanitizeSearch = (value: string): string => {
    let sanitizedSearch = value.replace(/[$%]/g, '').trim();

    const stripped = sanitizedSearch.replace(/[ym]/g, '').trim();
    
    if (!isNaN(Number(stripped)) && stripped !== '') {
        sanitizedSearch = stripped;
    }

    return sanitizedSearch;
};